import { FC, useCallback, useRef } from 'react';
import { Box } from '@mui/material';
import { Table, TableBody, TableCell, TableRow, Collapse } from '../uiLibraryImports';
import { InnerTableData } from './accordionTableTypes';
import SmallLoader from '../loaders/smallLoader';
import styles from './innerTable.module.scss';

const InnerTable: FC<InnerTableData> = (props: InnerTableData) => {
    const { hasMoreRows, loadMoreRows, isOpen, innerRows, isLoading } = props;
    const observer = useRef<IntersectionObserver | null>(null);
    const lastRowElementRef = useCallback(
        node => {
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    hasMoreRows && loadMoreRows?.();
                }
            });
            if (node) observer.current.observe(node);
        },
        [loadMoreRows, loadMoreRows]
    );

    return (
        <TableRow>
            <TableCell style={{ padding: '0px !important' }} colSpan={6} className={styles['inner-collapse']}>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <Box>
                        <Table>
                            <TableBody>
                                {isLoading ? (
                                    <SmallLoader size="50px" className={styles.loader} />
                                ) : (
                                    innerRows?.map((innerRow, i) => (
                                        <TableRow
                                            key={i}
                                            ref={innerRows?.length === i + 1 ? lastRowElementRef : undefined}
                                            className={styles.row}
                                        >
                                            <TableCell key={-1}></TableCell>
                                            {innerRow.map((rowItem, rowIndex) => (
                                                <TableCell key={rowIndex}>{rowItem}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
};

export default InnerTable;
